import { FC, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { accessTypes } from '@dbt-labs/selector';
import { DropdownButton, DropdownOption } from '@dbt-labs/sourdough';

import { AccessType } from '@/typings/dbt';
import { toTitleCase } from '@/util/string';

export type AccessLevelFilterDropdownProps = {
  label: string;
};

export const ACCESS_LEVEL_PARAM = 'access';

export const AccessLevelFilterDropdown: FC<AccessLevelFilterDropdownProps> = ({
  label,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const options = useMemo(
    () => [
      { label: 'All', value: 'all' },
      ...accessTypes.map((l): DropdownOption => ({ label: toTitleCase(l), value: l })),
    ],
    [],
  );

  const defaultOption = useMemo((): DropdownOption => {
    const qsValue = searchParams.get(ACCESS_LEVEL_PARAM) as AccessType | undefined;
    return options.find((o) => o.value === qsValue) || options[0];
  }, [searchParams, options]);

  return (
    <DropdownButton
      options={options}
      name={label}
      className="text-nowrap text-fgMain"
      listClassName="z-50"
      defaultOption={defaultOption}
      trackingId="explorer-access-level-filter"
      onChange={({ value }) => {
        if (typeof value !== 'string') return;
        if (value === 'all') {
          setSearchParams((p) => {
            p.delete(ACCESS_LEVEL_PARAM);
            return p;
          });
        } else {
          setSearchParams((p) => {
            p.set(ACCESS_LEVEL_PARAM, value);
            return p;
          });
        }
      }}
    />
  );
};
